import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Transactions, Users, Files, ErrorMessages, Accounts, Totals, Kpi, TextSlides, Conclusions } from "@app/_models";
import { Observable, of } from "rxjs";
import { TransactionFilters } from "@app/_helpers";

@Injectable({
  providedIn: "root",
})
export class ApiBackendService {
  constructor(private httpClient: HttpClient) {}

  public getTransactionByOrderId(orderId) {
    return this.httpClient.get<Transactions>(`${environment.api_backend.url}/transaction/order_id/` + orderId, {
      observe: "response",
    });
  }

  public getFiles() {
    return this.httpClient.get<Files[]>(`${environment.api_backend.url}/files`, {
      observe: "response",
    });
  }

  public getFilesPaginated(pageSize, pageIndex, filterQuery) {
    return this.httpClient.post(`${environment.api_backend.url}/files_paginated/` + pageSize + `?page=` + pageIndex, filterQuery, {
      observe: "response",
    });
  }

  public getUsersPaginated(pageSize, pageIndex, filterQuery) {
    return this.httpClient.post(`${environment.api_backend.url}/users_paginated/` + pageSize + `?page=` + pageIndex, filterQuery, {
      observe: "response",
    });
  }

  public getTransactions() {
    return this.httpClient.get<Transactions[]>(`${environment.api_backend.url}/transactions`, {
      observe: "response",
    });
  }

  public getTransactionsPaginated(pageSize: number, currentPage: number, filters?: TransactionFilters): Observable<any> {
    const params: any = {
      page: currentPage.toString(),
      pageSize: pageSize.toString(),
    };

    if (filters && Object.keys(filters).length > 0) {
      params.quick_filter = JSON.stringify(filters);
    }

    return this.httpClient.get(`${environment.api_backend.url}/transactions_paginated`, {
      params: params,
    });
  }

  public getTransactionsByUser(userId) {
    return this.httpClient.get<Transactions[]>(`${environment.api_backend.url}/transactions/user_id/` + userId, {
      observe: "response",
    });
  }

  public getMobilPayData(tranzactionType) {
    return this.httpClient.get<Transactions[]>(`${environment.api_backend.url}/mobilpay_client/` + tranzactionType, {
      observe: "response",
    });
  }

  public getUserById(id) {
    return this.httpClient.get(`${environment.api_backend.url}/user/` + id, {
      observe: "response",
    });
  }

  public getUsers() {
    return this.httpClient.get<Users[]>(`${environment.api_backend.url}/users`, {
      observe: "response",
    });
  }

  public updateFileUser(balanceProcessId, userId) {
    return this.httpClient.put(`${environment.api_backend.url}/update_file_user/` + balanceProcessId + "/" + userId, {
      observe: "response",
    });
  }

  public forgotPassword(email) {
    return this.httpClient.get<Users>(`${environment.api_backend.url}/forgot_password/` + email, {
      observe: "response",
    });
  }

  public updateMaxDesktops(userId: number, maxDesktops: number) {
    return this.httpClient.put(`${environment.api_backend.url}/users/${userId}/max-desktops`,
      { max_desktops: maxDesktops }, { observe: "response" });
  }

  public addCreditToUser(userId, credit) {
    return this.httpClient.get(`${environment.api_backend.url}/transactions/add_credit/` + userId + "/" + credit, {
      observe: "response",
    });
  }

  public removeCreditToUser(userId, credit) {
    return this.httpClient.get(`${environment.api_backend.url}/transactions/remove_credit/` + userId + "/" + credit, {
      observe: "response",
    });
  }

  public updateInvoice(invoiceDetails) {
    return this.httpClient.post(
      `${environment.api_backend.url}/pdf_invoice`,

      invoiceDetails,
      {
        observe: "response",
      }
    );
  }

  public getErrorMessages() {
    return this.httpClient.get<ErrorMessages[]>(`${environment.api_backend.url}/error_messages`, {
      observe: "response",
    });
  }

  public getTotals(processId) {
    return this.httpClient.get<Totals[]>(`${environment.api_backend.url}/bp_totals/` + processId, {
      observe: "response",
    });
  }

  public getAccounts(processId) {
    return this.httpClient.get<Accounts[]>(`${environment.api_backend.url}/bp_accounts/` + processId, {
      observe: "response",
    });
  }

  public getKpis(processId) {
    return this.httpClient.get<Kpi[]>(`${environment.api_backend.url}/bp_kpi/` + processId, {
      observe: "response",
    });
  }

  public getAllKpis() {
    return this.httpClient.get<Kpi[]>(`${environment.api_backend.url}/kpi`, {
      observe: "response",
    });
  }
  public getConclusions(processId) {
    return this.httpClient.get<Conclusions[]>(`${environment.api_backend.url}/bp_conclusions/` + processId, {
      observe: "response",
    });
  }
  public getTextSlides(processId) {
    return this.httpClient.get<TextSlides[]>(`${environment.api_backend.url}/text_slides/` + processId, {
      observe: "response",
    });
  }

  public getTextSlidesByLang(processID, language: string) {
    return this.httpClient.get<TextSlides[]>(`${environment.api_backend.url}/text_slides/${processID}?lang=${language}`, {
      observe: "response",
    });
  }

  public getTextSlideByKey(key: string) {
    return this.httpClient.get(`${environment.api_backend.url}/text_slide_by_key/${key}`, {
      observe: "response",
    });
  }

  public updateFileVisible(fileId) {
    return this.httpClient.put(`${environment.api_backend.url}/file/visible/` + fileId, {
      observe: "response",
    });
  }

  public updateFileNotes(fileId, notes) {
    return this.httpClient.put(`${environment.api_backend.url}/file/notes/` + fileId, notes, {
      observe: "response",
    });
  }

  public updateInvoiceNotes(id, notes) {
    return this.httpClient.put(`${environment.api_backend.url}/invoice/notes/` + id, notes, {
      observe: "response",
    });
  }
  public getAnafTokenStatus() {
    return this.httpClient.get(`${environment.api_backend.url}/check_anaf_token`, {
      observe: "response",
    });
  }
  public generareEfactura(id) {
    return this.httpClient.get(`${environment.api_backend.url}/generare_efactura/` + id, {
      observe: "response",
    });
  }
  public generareToken() {
    return this.httpClient.get(`${environment.api_backend.url}/start_auth`, {
      observe: "response",
    });
  }
  public refreshToken() {
    return this.httpClient.get(`${environment.api_backend.url}/refresh_token`, {
      observe: "response",
    });
  }
  public getFileDiag(id, lang) {
    return this.httpClient.get(`${environment.api_backend.url}/diagnostic/` + id, {
      params: { lang: lang },
      observe: "response",
    });
  }
  getUserReccurence(id) {
    return this.httpClient.get<any>(environment.api_backend.url + "/check_reccurence/" + id, {
      observe: "response",
    });
  }
  cancelUserReccurence(id) {
    return this.httpClient.post<any>(environment.api_backend.url + "/cancel_reccurence/" + id, {
      observe: "response",
    });
  }
  updateUsersCredit() {
    return this.httpClient.get<any>(environment.api_backend.url + "/update_users_credit", {
      observe: "response",
    });
  }
  public getSubscriptionsPaginated(pageSize, pageIndex, filterQuery) {
    return this.httpClient.post(`${environment.api_backend.url}/subscriptions_paginated/` + pageSize + `?page=` + pageIndex, filterQuery, {
      observe: "response",
    });
  }
  // Budget API methods
  getBudgetSources(): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets/sources`, { observe: "response" });
  }

  getBudgets(): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets`, { observe: "response" });
  }

  getBudgetsPaginated(pageSize: number, pageIndex: number, filterQuery: any): Observable<any> {
    return this.httpClient.post(
      `${environment.api_backend.url}/budgets_paginated/${pageSize}?page=${pageIndex}`,
      filterQuery,
      { observe: "response" }
    );
  }

  getBudget(id: number): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets/${id}`, { observe: "response" });
  }

  createBudget(data: any): Observable<any> {
    return this.httpClient.post(`${environment.api_backend.url}/budgets`, data, { observe: "response" });
  }

  updateBudget(id: number, data: any): Observable<any> {
    return this.httpClient.put(`${environment.api_backend.url}/budgets/${id}`, data, { observe: "response" });
  }

  deleteBudget(id: number): Observable<any> {
    return this.httpClient.delete(`${environment.api_backend.url}/budgets/${id}`, { observe: "response" });
  }

  getBudgetVsRealized(budgetId: number, params: any): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets/${budgetId}/vs-realized`, { params, observe: "response" });
  }

  sendBudgetByEmail(budgetId: number, email: string): Observable<any> {
    return this.httpClient.post(`${environment.api_backend.url}/budgets/${budgetId}/export/email`, { email }, { observe: "response" });
  }

  getBudgetSourceAccounts(budgetId: number): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets/${budgetId}/source-accounts`, { observe: "response" });
  }

  getBudgetMonthAssignments(budgetId: number): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets/${budgetId}/month-assignments`, { observe: "response" });
  }

  updateBudgetMonthAssignments(budgetId: number, assignments: any[]): Observable<any> {
    return this.httpClient.put(`${environment.api_backend.url}/budgets/${budgetId}/month-assignments`, { assignments }, { observe: "response" });
  }

  getBudgetAccountLines(budgetId: number): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets/${budgetId}/account-lines`, { observe: "response" });
  }

  addBudgetAccountLine(budgetId: number, sortOrder: number, accountCode: string, accountDescription: string): Observable<any> {
    return this.httpClient.post(`${environment.api_backend.url}/budgets/${budgetId}/account-lines`,
      { sortOrder, accountCode, accountDescription }, { observe: "response" });
  }

  getBudgetAvailableAccounts(budgetId: number, sortOrder: number): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets/${budgetId}/available-accounts/${sortOrder}`, { observe: "response" });
  }

  getBudgetAutoMatch(month: number, year: number): Observable<any> {
    return this.httpClient.get(
      `${environment.api_backend.url}/budgets/auto-match?month=${month}&year=${year}`,
      { observe: "response" }
    );
  }

  getBudgetFullComparison(budgetId: number): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets/${budgetId}/comparison-full`, { observe: "response" });
  }

  exportBudgetComparisonExcel(budgetId: number): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets/${budgetId}/export/comparison-excel`, { responseType: 'blob', observe: "response" });
  }

  exportBudgetComparisonPdf(budgetId: number): Observable<any> {
    return this.httpClient.get(`${environment.api_backend.url}/budgets/${budgetId}/export/comparison-pdf`, { responseType: 'blob', observe: "response" });
  }

  sendBudgetComparisonByEmail(budgetId: number, email: string): Observable<any> {
    return this.httpClient.post(`${environment.api_backend.url}/budgets/${budgetId}/export/comparison-email`, { email }, { observe: "response" });
  }

  searchUsers(searchTerm: string): Observable<any> {
    if (!searchTerm?.trim()) {
      return of({ body: [] });
    }
    return this.httpClient.get<any>(`${environment.api_backend.url}/users_search`, {
      params: { search_term: searchTerm },
      observe: "response",
    });
  }
}
